export const REACT_APP_NAME =
  process.env.REACT_APP_NAME || 'customer-portal-touchlatam';
export const MAIN_BACKEND_URL =
  process.env.REACT_APP_MAIN_BACKEND_URL || 'someapi.com';
export const APP_LANGUAGE = process.env.REACT_APP_LANGUAGE || 'en';
export const ENV = process.env.NODE_ENV || 'development';
export const OHLA_DOMAIN = process.env.REACT_APP_OHLA_DOMAIN || 'ohla.com';
export const TEST_DOMAIN = 'portal.pukifoods.com';
export const OHLA_DOMAIN_V2 = 'www.portal-ohla.touchlatam.com';
export const GOOGLE_MAP_API_KEY =
  process.env.REACT_APP_GOOGLE_MAP_API_KEY || 'your-google-map-api-key';

export enum MenuType {
  STANDARD_MENU = 'STANDARD_MENU',
  IFRAME_VIEWER = 'IFRAME_VIEWER',
  POWER_BI_REPORT = 'POWER_BI_REPORT',
  PARENT_MENU = 'PARENT_MENU',
  URL_REDIRECT = 'URL_REDIRECT',
  PDF_VIEWER = 'PDF_VIEWER',
  OFFICE_VIEWER = 'OFFICE_VIEWER',
}
